// API Configuration
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '';

// Helper to get full API URL
export const getApiUrl = (path: string): string => {
  // If path already starts with http, return as-is
  if (path.startsWith('http')) return path;

  // Ensure path starts with /
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  // In production, prepend the API base URL
  // In development with Vite proxy, API_BASE_URL is empty so paths work with proxy
  return `${API_BASE_URL}${normalizedPath}`;
};
